import { Box, Dialog } from "@mui/material";
import styled from "styled-components";
import { BaseFormStyled } from "../base-form/base-form.styles";

export const DialogComponentStyled = styled(Dialog)<{ width?: string }>`
  .MuiPaper-root {
    width: 100%;
    max-width: ${(p) => p.width || "418px"};
  }
`;

export const BoxStyled = styled(Box)<{ width?: string }>`
  /* width: ${(p) => p.width || "418px"}; */
  padding: 16px 16px 21px 16px;
  outline: none;
  .title-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .MuiTypography-root {
      font-weight: 600;
      font-size: 20px;
      color: var(--dark-gray-color);
    }
    .close-icon {
      margin-left: auto;
      width: 20px;
      height: 20px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      .MuiSvgIcon-root {
        color: #70767b;
        display: block;
        width: 20px;
        height: 20px;
      }
    }
  }
  .content-container {
    padding-top: 14px;
  }
`;

export const ModalButtonsContainer = styled(Box)`
  padding-top: 16px;
  .primary-button {
    .MuiButtonBase-root {
      display: inline-flex;
      width: 100%;
      align-items: center;
      justify-content: center;
      font-size: 16px !important;
      font-weight: 600 !important;
    }
  }
`;

export const ModalBaseForm = styled(BaseFormStyled)`
  gap: 16px;
  .field-wrapper {
    .MuiTypography-root {
      color: var(--medium-gray-color);
      font-size: 12px;
    }
    .MuiFormControl-root {
      .MuiInputBase-root {
        .MuiInputBase-input {
          height: 40px;
          font-size: 14px;
          color: #606060;
        }
        .MuiOutlinedInput-notchedOutline {
          border: 1px solid #c3ccd7;
          box-shadow: 0px 1px 2px 0px #1018280d;
        }
      }
    }
    .MuiInputBase-root {
      .MuiSelect-select {
        font-size: 14px;
        color: #606060;
      }
      .MuiOutlinedInput-notchedOutline {
        border: 1px solid #c3ccd7;
        box-shadow: 0px 1px 2px 0px #1018280d;
      }
    }
  }
  .time-picker {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    gap: 14px;
  }
  .MuiInputBase-root {
    border-radius: 16px;
    height: 40px;
    input {
      height: 40px;
    }
    fieldset {
      height: 40px;
    }
  }
  .MuiDateCalendar-root {
    border: 1px solid #c3ccd7;
    border-radius: 12px;
    width: 100%;
  }
`;
